import { render, staticRenderFns } from "./pdfdetail.vue?vue&type=template&id=34b6a0bf&"
import script from "./pdfdetail.vue?vue&type=script&lang=js&"
export * from "./pdfdetail.vue?vue&type=script&lang=js&"
import style0 from "./pdfdetail.vue?vue&type=style&index=0&id=34b6a0bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports